export default "__VITE_ASSET__609fbf07__"